module.exports = __webpack_public_path__ + "static/Assessment-ac0c7b91a0f6b54930cbb5045ad9434f.png";